import { Setting } from '../../modules/settings'

export interface SettingState {
  settings: Setting[]
}

export const initialState: SettingState = {
  settings: []
}

export const settingStoreKey = 'setting'
